var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvatar4 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_694",
    "data-name": "Ellipse 694",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_299",
    "data-name": "Mask Group 299",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903",
    transform: "translate(-2.154 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_691",
    "data-name": "Ellipse 691",
    cx: 37.692,
    cy: 37.692,
    r: 37.692,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1902",
    "data-name": "Group 1902",
    transform: "translate(7.205 10.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44342",
    "data-name": "Path 44342",
    d: "M2071.887,4666.9s2.45-5.685,6.69-5.093,5.968,5.053,6.13,6.082-1.418,5.255-2.527,5.742a4.814,4.814,0,0,1-2.114.61,60.242,60.242,0,0,1-8.417-.178C2071.054,4673.85,2071.887,4666.9,2071.887,4666.9Z",
    transform: "translate(-2051.227 -4655.87)",
    fill: "#dd816c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44343",
    "data-name": "Path 44343",
    d: "M2066.972,4688.468a7.6,7.6,0,0,0,5.854,2.316c3.132-.14,6.369-3.158,6.369-3.158a17.349,17.349,0,0,1-1.737-4.759c-.569-2.761-.942-5.418-.469-6.067.38-.52,1.419-.966,2.17-2.152a2.536,2.536,0,0,0,.247-.614c.444-1.584.374-2.268-.6-3.09s-2.068,0-2.392,1.121c-.146.508.389,1.608.2,3.24a11.725,11.725,0,0,1-2.317,5.556c-1.562,2.117-5.756,2.69-5.756,2.69a13.886,13.886,0,0,1-.9,2.965C2067.048,4687.788,2066.593,4687.879,2066.972,4688.468Z",
    transform: "translate(-2042.553 -4657.747)",
    fill: "#dc806b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44344",
    "data-name": "Path 44344",
    d: "M2065.468,4672.3c-.8-.132-.707,4,.62,5.873a4.5,4.5,0,0,0,2.719,1.761,9.183,9.183,0,0,0,3.639-.016,6.733,6.733,0,0,0,4.887-3.346,9.461,9.461,0,0,0,1.666-4.7c.326-2.368-.49-2.775.2-3.754s1.514-1.157,2.4-.221.229,2.8-.055,3.208a5.689,5.689,0,0,1-1.854,1.863c-1.071.64-.5,2.261-.5,2.261a8.379,8.379,0,0,0,2.143-1.817c1.136-1.3,1.316-2.021,2.189-4a15.152,15.152,0,0,0,1.222-5.77,5.978,5.978,0,0,0-5.012-5.431c-1.163-.222-1.557-3.075-5.643-3.664s-4.562-.216-7.243,1.221a5.994,5.994,0,0,0-3.411,5.348c0,1.642,1.543,4.325,2.211,4.291s1.2-3.28,3.638-4.291a5.993,5.993,0,0,1,5.186,0,6.056,6.056,0,0,1,3.236,4.291,7.535,7.535,0,0,1-1.829,6.636C2074.715,4672.994,2066.269,4672.435,2065.468,4672.3Z",
    transform: "translate(-2044.95 -4654.283)",
    fill: "#20110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44345",
    "data-name": "Path 44345",
    d: "M2069.865,4693a56.684,56.684,0,0,1,15.6,7.619c8.06,5.574,11.348,24.575,11.348,24.575h-63.607s2.668-17.472,8.729-22.906,15.513-8.832,15.513-8.832,2.613,2.6,5.909,2.408S2069.865,4693,2069.865,4693Z",
    transform: "translate(-2033.211 -4663.284)",
    fill: "#eee4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44346",
    "data-name": "Path 44346",
    d: "M5361.508,1876.686a3.191,3.191,0,0,1,1.486-.418,5.021,5.021,0,0,1,1.728.418",
    transform: "translate(-5334.57 -1865.614)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44347",
    "data-name": "Path 44347",
    d: "M5362.184,1876.753a7.677,7.677,0,0,1,1.4-.222,6.086,6.086,0,0,1,1.315.1",
    transform: "translate(-5341.729 -1865.68)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_692",
    "data-name": "Ellipse 692",
    transform: "translate(21.18 12.316)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.788,
    cy: 0.788,
    rx: 0.788,
    ry: 0.788,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.788,
    cy: 0.788,
    rx: 0.288,
    ry: 0.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_693",
    "data-name": "Ellipse 693",
    transform: "translate(27.662 12.316)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.788,
    cy: 0.788,
    rx: 0.788,
    ry: 0.788,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.788,
    cy: 0.788,
    rx: 0.288,
    ry: 0.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44348",
    "data-name": "Path 44348",
    d: "M5358.677,1880.152a14.577,14.577,0,0,0-1.335,3.041c.03.55,1.5.614,1.5.614Z",
    transform: "translate(-5333.525 -1866.585)",
    fill: "#ca6a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44349",
    "data-name": "Path 44349",
    d: "M5357.655,1886.39l4.1-.063s-1.2,1.593-2.227,1.608S5357.655,1886.39,5357.655,1886.39Z",
    transform: "translate(-5334.899 -1866.392)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvatar4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-4.5a871189.svg";
export { ForwardRef as ReactComponent };